import { useState } from "react";
import Navbar from "./components/Navbar";
import NewsLetter from "./components/NewsLetter";
import "./css/Home.css";
import "./css/CustomModal.css";

import heroBg from "../images/HomeBgBanner.png";
import heroImage from "../images/userapp1.png"; // Main hero image for the right side

// You can replace these with actual image paths or icons (like react-icons)

// New Section Image (Update path to your actual image)
import aboutImage from "../images/AboutRight.png";

// NEW Imports for this section (Update paths to your actual files)



import { Link } from "react-router-dom";

import { useNavigate } from 'react-router-dom';

// Import your images (make sure these paths match your project setup)

import Footer from "./components/Footer";

import {
    FaCheckCircle, 
    FaSnowflake,
    FaFan,
    FaTools,
    FaMicrochip,
    FaTv,
} from "react-icons/fa";
import DownloadApp from "./components/DownloadApp";
import ForumCrestest from "./components/ForumCrestest.js";
import KirnavaliCrestest from "./components/KirnavaliCrestest.js";

function Home() {

    const navigate = useNavigate();

    const [activeTooltip, setActiveTooltip] = useState(null);

    const [showComingSoonModal, setShowComingSoonModal] = useState(false);

    const handleCloseComingSoonModal = () => {
        setShowComingSoonModal(false);
    };

    const featureDetails = {
        one: {
            title: "AC Services",
            desc: "Keep your air conditioner running efficiently with professional servicing, cleaning, repair, installation, and maintenance services.",
            points: ["AC Service & Cleaning", "AC Repair & Installation"]
        },

        two: {
            title: "AC Repair & Maintenance",
            desc: "Get reliable AC repair and maintenance services to keep your cooling system efficient, comfortable, and running smoothly.",
            points: ["AC Gas Refill & Repair", "Preventive Maintenance"]
        },

        three: {
            title: "Refrigerator Services",
            desc: "Get professional refrigerator repair and maintenance services to keep your appliance cooling properly and working efficiently.",
            points: ["Cooling & Compressor Repair", "Gas Refill & Maintenance"]
        },

        four: {
            title: "Washing Machine Services",
            desc: "Keep your washing machine performing at its best with professional inspection, repair, installation, and maintenance services.",
            points: ["Washing Machine Repair", "Motor, Drum & Drainage Issues"]
        },

        five: {
            title: "Microwave & Oven Services",
            desc: "Get expert repair and maintenance for microwave ovens and kitchen appliances to ensure safe and reliable everyday use.",
            points: ["Microwave & Oven Repair", "Heating & Electrical Issues"]
        },

        six: {
            title: "TV & Home Appliances",
            desc: "Get professional support for your TV and essential home appliances, including installation, troubleshooting, repair, and maintenance.",
            points: ["TV Installation & Repair", "Home Appliance Maintenance"]
        }
    };



    return (
        <>
            {/* Existing Hero Section */}
            <section
                className="hero-section"
                style={{
                    backgroundImage: `url(${heroBg})`,
                }}
            >
                <Navbar />

                <div className="container hero-content">
                    <div className="row align-items-center">
                        {/* Left Section (Increased Width) */}
                        <div className="col-lg-7 col-md-12 mb-4 mb-lg-0">

                            <div className="hero-left">
                                <p className="hero-small-text">
                                    AI-Powered Smart Home Services
                                </p>

                                <h1 className="hero-heading">
                                    <span style={{ color: "#7B87D3" }}>
                                        Fixovera
                                    </span>
                                    &nbsp; : Your Home, Our Care
                                </h1>

                                <p className="hero-sub-text" style={{ color: "white" }}>
                                    Discover reliable, convenient, and smart household services designed
                                    to make home maintenance easier. Connect with trusted professionals
                                    and get the right service whenever you need it.
                                </p>

                                <p className="hero-sub-text" style={{ color: "white" }}>
                                    From everyday repairs to essential home maintenance, Fixovera brings
                                    quality services, verified professionals, transparent bookings, and
                                    seamless support together in one smart platform.
                                </p>


                                {/* <a
                                    href="https://fixovera.com/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="btn hero-btn"
                                >
                                    GET STARTED
                                </a>
                                */}

                            </div>



                        </div>

                        {/* Right Section (Circles) */}
                        <div className="col-lg-5 col-md-12">
                            <div className="hero-right hero-full-image">
                                <img
                                    src={heroImage}
                                    alt="Hero Main"
                                    className="hero-full-width-img"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Sleek 6-Box Features Section with Zero Section Padding */}
            <section className="features-section">
                <div className="container px-0">
                    <div className="row g-0">

                        {/* Feature Box 1 */}
                        <div
                            className="col-md-4 col-lg-2 feature-box-wrapper"
                            onMouseEnter={() => setActiveTooltip('one')}
                            onMouseLeave={() => setActiveTooltip(null)}
                        >
                            <div className="feature-box box-blue">
                                <FaSnowflake style={{
                                    fontSize: "48px",
                                    color: "#ffffff",
                                    marginBottom: "15px"
                                }} />
                                <h3 className="feature-title">AC SERVICES</h3>
                            </div>

                            {activeTooltip === 'one' && (
                                <div className="feature-hover-tooltip-card shadow-lg">
                                    <h4 className="tooltip-heading">
                                        {featureDetails.one.title}
                                    </h4>

                                    <p className="tooltip-desc">
                                        {featureDetails.one.desc}
                                    </p>

                                    <ul className="tooltip-points-list">
                                        {featureDetails.one.points.map((pt, idx) => (
                                            <li key={idx}>
                                                <FaCheckCircle className="tooltip-check-icon" /> {pt}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            )}
                        </div>


                        {/* Feature Box 2 */}
                        <div
                            className="col-md-4 col-lg-2 feature-box-wrapper"
                            onMouseEnter={() => setActiveTooltip('two')}
                            onMouseLeave={() => setActiveTooltip(null)}
                        >
                            <div className="feature-box box-green">
                                <FaFan style={{
                                    fontSize: "48px",
                                    color: "#ffffff",
                                    marginBottom: "15px"
                                }} />
                                <h3 className="feature-title">AC REPAIR & MAINTENANCE</h3>
                            </div>

                            {activeTooltip === 'two' && (
                                <div className="feature-hover-tooltip-card shadow-lg">
                                    <h4 className="tooltip-heading">
                                        {featureDetails.two.title}
                                    </h4>

                                    <p className="tooltip-desc">
                                        {featureDetails.two.desc}
                                    </p>

                                    <ul className="tooltip-points-list">
                                        {featureDetails.two.points.map((pt, idx) => (
                                            <li key={idx}>
                                                <FaCheckCircle className="tooltip-check-icon" /> {pt}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            )}
                        </div>


                        {/* Feature Box 3 */}
                        <div
                            className="col-md-4 col-lg-2 feature-box-wrapper"
                            onMouseEnter={() => setActiveTooltip('three')}
                            onMouseLeave={() => setActiveTooltip(null)}
                        >
                            <div className="feature-box box-orange">
                                <FaSnowflake style={{
                                    fontSize: "48px",
                                    color: "#ffffff",
                                    marginBottom: "15px"
                                }} />
                                <h3 className="feature-title">REFRIGERATOR SERVICES</h3>
                            </div>

                            {activeTooltip === 'three' && (
                                <div className="feature-hover-tooltip-card shadow-lg">
                                    <h4 className="tooltip-heading">
                                        {featureDetails.three.title}
                                    </h4>

                                    <p className="tooltip-desc">
                                        {featureDetails.three.desc}
                                    </p>

                                    <ul className="tooltip-points-list">
                                        {featureDetails.three.points.map((pt, idx) => (
                                            <li key={idx}>
                                                <FaCheckCircle className="tooltip-check-icon" /> {pt}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            )}
                        </div>


                        {/* Feature Box 4 */}
                        <div
                            className="col-md-4 col-lg-2 feature-box-wrapper"
                            onMouseEnter={() => setActiveTooltip('four')}
                            onMouseLeave={() => setActiveTooltip(null)}
                        >
                            <div className="feature-box box-purple">
                                <FaTools style={{
                                    fontSize: "48px",
                                    color: "#ffffff",
                                    marginBottom: "15px"
                                }} />
                                <h3 className="feature-title">WASHING MACHINE SERVICES</h3>
                            </div>

                            {activeTooltip === 'four' && (
                                <div className="feature-hover-tooltip-card shadow-lg">
                                    <h4 className="tooltip-heading">
                                        {featureDetails.four.title}
                                    </h4>

                                    <p className="tooltip-desc">
                                        {featureDetails.four.desc}
                                    </p>

                                    <ul className="tooltip-points-list">
                                        {featureDetails.four.points.map((pt, idx) => (
                                            <li key={idx}>
                                                <FaCheckCircle className="tooltip-check-icon" /> {pt}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            )}
                        </div>


                        {/* Feature Box 5 */}
                        <div
                            className="col-md-4 col-lg-2 feature-box-wrapper"
                            onMouseEnter={() => setActiveTooltip('five')}
                            onMouseLeave={() => setActiveTooltip(null)}
                        >
                            <div className="feature-box box-red">
                                <FaMicrochip style={{
                                    fontSize: "48px",
                                    color: "#ffffff",
                                    marginBottom: "15px"
                                }} />
                                <h3 className="feature-title">MICROWAVE & OVEN SERVICES</h3>
                            </div>

                            {activeTooltip === 'five' && (
                                <div className="feature-hover-tooltip-card shadow-lg">
                                    <h4 className="tooltip-heading">
                                        {featureDetails.five.title}
                                    </h4>

                                    <p className="tooltip-desc">
                                        {featureDetails.five.desc}
                                    </p>

                                    <ul className="tooltip-points-list">
                                        {featureDetails.five.points.map((pt, idx) => (
                                            <li key={idx}>
                                                <FaCheckCircle className="tooltip-check-icon" /> {pt}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            )}
                        </div>


                        {/* Feature Box 6 */}
                        <div
                            className="col-md-4 col-lg-2 feature-box-wrapper"
                            onMouseEnter={() => setActiveTooltip('six')}
                            onMouseLeave={() => setActiveTooltip(null)}
                        >
                            <div className="feature-box box-teal">
                                <FaTv style={{
                                    fontSize: "48px",
                                    color: "#ffffff",
                                    marginBottom: "15px"
                                }} />
                                <h3 className="feature-title">TV & HOME APPLIANCES</h3>
                            </div>

                            {activeTooltip === 'six' && (
                                <div className="feature-hover-tooltip-card shadow-lg">
                                    <h4 className="tooltip-heading">
                                        {featureDetails.six.title}
                                    </h4>

                                    <p className="tooltip-desc">
                                        {featureDetails.six.desc}
                                    </p>

                                    <ul className="tooltip-points-list">
                                        {featureDetails.six.points.map((pt, idx) => (
                                            <li key={idx}>
                                                <FaCheckCircle className="tooltip-check-icon" /> {pt}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            )}
                        </div>

                    </div>
                </div>


            </section>


            {/* 3. NEW: Split Content & Image Section */}
            <section className="info-section">
                <div className="container">
                    <div className="row align-items-stretch">

                        {/* Left Side Content */}
                        <div className="col-lg-6 d-flex align-items-center">
                            <div className="info-left-content">


                                <p className="info-small-text">
                                    DISCOVER FIXOVERA
                                </p>

                                <h2 className="info-heading">
                                    About Us
                                </h2>

                                {/* The Zigzag Accent */}
                                <div className="zigzag-border mb-3"></div>

                                <p className="info-sub-text">
                                    <Link to="/" className="wiki-link">
                                        Fixovera
                                    </Link>{" "}
                                    is a smart home appliance and AC service marketplace designed to make
                                    appliance maintenance simple, convenient, and reliable. We connect
                                    customers with skilled professionals for a wide range of AC and home
                                    appliance services.
                                </p>

                                <p className="info-sub-text mt-3">
                                    From{" "}
                                    <span className="wiki-link">
                                        <Link to="/ac" className="wiki-link">
                                            AC servicing
                                        </Link>
                                    </span>{" "}
                                    and{" "}
                                    <span className="wiki-link">
                                        <Link to="/ac" className="wiki-link">
                                            AC repair
                                        </Link>
                                    </span>{" "}

                                    to refrigerator, washing machine, microwave, oven, TV, and other home
                                    appliance services, Fixovera brings essential appliance solutions
                                    together on one easy-to-use platform.
                                </p>

                                <p className="info-sub-text mt-3">
                                    Our goal is to create a dependable appliance service experience by
                                    connecting customers with trusted professionals while making booking,
                                    service management, communication, and support easier throughout the
                                    entire process.
                                </p>


                                <Link to="/about" className="btn info-btn mt-3">
                                    ABOUT FIXOVERA
                                </Link>

                            </div>


                        </div>


                        {/* Right Side Image (Full Width & Height of Grid Box) */}
                        <div className="col-lg-6 px-0">
                            <div className="info-right-img-wrap">
                                <img
                                    src={aboutImage}
                                    alt="About Us"
                                    className="info-full-image"
                                />
                            </div>
                        </div>

                    </div>
                </div>
            </section>



            < ForumCrestest />

            {/* Download App Section */}
            <DownloadApp />

            < KirnavaliCrestest />







            {/* 8. NEW: Modular Newsletter Component */}
            <NewsLetter />

            {/* 9. NEW: Footer Component */}
            <Footer />
        </>
    );
}

export default Home;